import { authAxios } from "setups/axios";
import { toastMessage } from "utils/toastMessage";

const extractErrorMessage = (error) => {
  if (error?.response?.data?.message) return error.response.data.message;
  if (error?.message) return error.message;
  return "Request failed";
};

const request = async (config, { silent = false } = {}) => {
  try {
    const response = await authAxios()(config);
    return response.data;
  } catch (error) {
    const msg = extractErrorMessage(error);
    if (!silent) toastMessage(msg, "error");
    throw error;
  }
};

export const api = {
  get: (url, { params, headers, silent } = {}) =>
    request({ method: "GET", url, params, headers }, { silent }),
  post: (url, data, { params, headers, silent } = {}) =>
    request({ method: "POST", url, data, params, headers }, { silent }),
  put: (url, data, { params, headers, silent } = {}) =>
    request({ method: "PUT", url, data, params, headers }, { silent }),
  patch: (url, data, { params, headers, silent } = {}) =>
    request({ method: "PATCH", url, data, params, headers }, { silent }),
  delete: (url, { params, headers, silent } = {}) =>
    request({ method: "DELETE", url, params, headers }, { silent }),
};

export default api;


